import { TableColumn } from '../../components/DataTable/TableColumn';
import { SalesReport } from '../../interfaces/Report/SalesReport/SalesReport';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { PriceColumn } from '../../components/DataTable/PriceColumn';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import { Period } from '../../interfaces/Period';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { ReportRow } from '../../interfaces/Report/ReportRow';

export const salesReportColumns: TableColumn<SalesReport>[] = [
  {
    id: 'total-orders',
    name: 'Toplam Sipariş',
    accessor: (row) => <TextColumn value={row.totalOrders.toString()} />,
  },
  {
    id: 'total-products',
    name: 'Toplam Ürün Adedi',
    accessor: (row) => <TextColumn value={row.totalProducts.toString()} />,
  },
  {
    id: 'total-sub-total',
    name: 'Ara Toplam',
    accessor: (row) => <PriceColumn value={row.totalSubTotal} />,
  },
  {
    id: 'total-shipping-cost',
    name: 'Kargo',
    accessor: (row) => <PriceColumn value={row.totalShippingCost} />,
  },
  {
    id: 'total-discount',
    name: 'İndirim',
    accessor: (row) => <PriceColumn value={row.totalDiscount} />,
  },
  {
    id: 'total',
    name: 'Toplam',
    accessor: (row) => <PriceColumn value={row.total} />,
  },
];

export function getCreatedAtColumn<T extends ReportRow>(
  period?: Period,
): TableColumn<T> {
  return {
    id: 'created-at',
    name: 'Tarih',
    accessor: (row) => <DateColumn value={row.createdAt} period={period} />,
  };
}

type SalesReportTableProps = {
  rows: SalesReport[];
  period?: Period;
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const SalesReportTable = (props: SalesReportTableProps) => {
  return (
    <DataTable
      columns={[getCreatedAtColumn(props.period), ...salesReportColumns]}
      totalCount={props.totalCount}
      rows={props.rows}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
    />
  );
};
